import React, { useState, useEffect } from "react";
import { db, whatsappLink } from "../../config/FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";

const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState({
    title: "",
    subtitle: "",
    ctaText: "",
    isActive: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "config", "notification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setNotification({
            title: data.title || "",
            subtitle: data.subtitle || "",
            ctaText: data.ctaText || "",
            isActive: data.isActive !== undefined ? data.isActive : true,
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeVisible = window.scrollY > 600 && notification.isActive;
      if (shouldBeVisible !== isVisible) {
        setIsVisible(shouldBeVisible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isVisible, notification.isActive]);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("ctaDismissed", "true");
  };

  if (isDismissed || !notification.isActive) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: isVisible ? "30px" : "-300px",
        left: "0",
        right: "0",
        zIndex: 1000,
        transition: "bottom 0.3s ease",
        padding: "0 20px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background:
            "linear-gradient(269.52deg, #E32285 28.23%, #9747FF 79.08%)",
          color: "white",
          padding: "25px 20px",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          maxWidth: "1200px",
          width: "100%",
          position: "relative", // Added for absolute positioning of close button
        }}
      >
        {/* Close button positioned exactly as in the reference image */}
        <button
          onClick={handleDismiss}
          style={{
            position: "absolute",
            top: "-8px",
            right: "-8px",
            background: "white",
            border: "1px solid #e2e8f0",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            padding: 0,
            zIndex: 1,
          }}
        >
          <IoMdClose size={14} color="#4a5568" />
        </button>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              marginBottom: "2px",
            }}
          >
            {notification.subtitle}
          </span>
          <span
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {notification.title}
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <Link
            to={whatsappLink}
            style={{
              background: "white",
              color: "#b01a67",
              padding: "8px 16px",
              borderRadius: "20px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            {notification.ctaText}
            <FaLongArrowAltRight style={{ marginLeft: "8px" }} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FloatingNotification;
